import classNames from 'classnames'
import { string } from 'prop-types'

import { isMobile } from 'shared/utils/deviceClassUtils'
import ShopLogo from 'views/components/atoms/ShopLogo'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

import './LogoSmall.scss'

const LogoSmall = ({ title, alt, shopURL, tenant }) => {
  const { deviceClass } = usePublicConfig()

  const logoLinkClass = classNames('a-LogoSmall', {
    'u-hidden@medium': !isMobile(deviceClass),
  })

  return (
    <a className={logoLinkClass} href={shopURL}>
      <ShopLogo
        tenant={tenant}
        alt={alt}
        title={title}
        className="a-LogoSmall__img"
        mobile
      />
    </a>
  )
}

LogoSmall.propTypes = {
  tenant: string.isRequired,
  shopURL: string.isRequired,
  title: string.isRequired,
  alt: string.isRequired,
}

export default LogoSmall
